'use client';

import { atomWithStorage } from '@capsicum/common';

export const initialSchedulePermissionRequestAtom = atomWithStorage<'never' | null | number>(
	'initialSchedulePermissionRequest',
	null
);
export const actionNextSchedulePermissionRequestAtom = atomWithStorage<'never' | null | number>(
	'actionNextSchedulePermissionRequest',
	null
);
